module.exports = __webpack_public_path__ + "img/Sao Tome and Prince.0970763b.svg";